export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

//signautre Actions
export const GET_SIGNATURE = "GET_SIGNATURE";
export const GET_SIGNATURE_SUCCESS = "GET_SIGNATURE_SUCCESS";
export const GET_SIGNATURE_FAILURE = "GET_SIGNATURE_FAILURE";
export const CREATE_SIGNATURE = "CREATE_SIGNATURE";
export const CREATE_SIGNATURE_SUCCESS = "CREATE_SIGNATURE_SUCCESS";
export const CREATE_SIGNATURE_FAILURE = "CREATE_SIGNATURE_FAILURE";
export const UPLOAD_SIGNATURE_FILE = "UPLOAD_SIGNATURE_FILE";
export const UPDATE_SIGNATURE = "UPDATE_SIGNATURE";
export const REMOVE_SIGNATURE = "REMOVE_SIGNATURE";
export const FETCH_SIGNER_DATA = "FETCH_SIGNER_DATA";
export const FETCH_SIGNER_CHART_DATA = "FETCH_SIGNER_CHART_DATA";
export const FETCH_TEMPLATE_DATA = "FETCH_TEMPLATE_DATA";
export const FETCH_SIGNER_DATA_SUCCESS = "FETCH_SIGNER_DATA_SUCCESS";
export const FETCH_SIGNER_DATA_FAILURE = "FETCH_SIGNER_DATA_FAILURE";

//submit Cosent
export const SUBMIT_CONSENT = "SUBMIT_CONSENT";
export const SUBMIT_CONSENT_SUCCESS = "SUBMIT_CONSENT_SUCCESS";
export const SUBMIT_CONSENT_FAILURE = "SUBMIT_CONSENT_FAILURE";
export const CLOSE_SIGNATURE_MODAL = "CLOSE_SIGNATURE_MODAL";
export const OPEN_SIGNATURE_MODAL = "OPEN_SIGNATURE_MODAL";
